import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../inc/header';
import Footer from '../inc/footer';

function PrivacyPolicy() {
    return (
        <>
            <style type="text/css">
                {`
                    #content_section p, ul, h1, h4 {
                        text-align: justify !important;
                        color: #000;
                    }

                    .service-description {
                        text-align: justify !important;
                        color: #000;
                        line-height: 1.8;
                    }

                    .service-description ul li::marker {
                        color: #E6178B !important;
                    }

                    .service-description h4 {
                        color: #272761;
                        font-weight: 700;
                        margin-top: 30px;
                    }

                    .service-description p, .service-description ul {
                        margin-bottom: 15px;
                    }

                    .page-header {
                        background-size: cover;
                        background-position: center;
                        color: #fff;
                        padding: 100px 0;
                    }

                    .page-header h1 {
                        font-weight: 700;
                        color: white;
                    }

                    @media (max-width: 768px) {
                        .page-header {
                            padding: 60px 0;
                        }
                    }
                `}
            </style>

            <Helmet>
                <title>Privacy Policy | Gulf Strategic Partners Co.</title>
            </Helmet>

            <Header />

            <main role="main" className="main">

                {/* ======= PAGE HEADER ======= */}
                <section
                    className="page-header page-header-modern page-header-background overlay overlay-color-dark overlay-show overlay-op-7"
                    style={{
                        backgroundImage: "url('/assets/img/slides/page-header-services.jpg')",
                    }}
                >
                    <div className="container">
                        <div className="row mt-5">
                            <div className="col-md-12 align-self-center text-center">
                                <h1 className="text-10">
                                    <strong>Privacy Policy</strong>
                                </h1>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ======= PRIVACY POLICY CONTENT ======= */}
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="service-description">
                                <p>
                                    At <strong>Gulf Strategic Partners Co. (GSP)</strong>, we value your privacy and are committed to
                                    protecting the personal data of our website visitors, clients, partners, and stakeholders.
                                    This Privacy Policy explains how we collect, use, disclose, and safeguard your information when
                                    you visit our website: <a href="https://www.gspwll.com" target="_blank" rel="noreferrer">www.gspwll.com</a>.
                                </p>
                                <p>By using our website, you agree to the terms of this policy.</p>

                                <h4>1. Information We Collect</h4>
                                <p>We may collect the following types of information:</p>
                                <p><strong>a. Personal Information</strong></p>
                                <ul>
                                    <li>Name, email address, phone number, company name, job title</li>
                                    <li>Any other information you provide via contact forms or inquiries</li>
                                </ul>
                                <p><strong>b. Technical Data</strong></p>
                                <ul>
                                    <li>IP address</li>
                                    <li>Browser type and version</li>
                                    <li>Device information</li>
                                    <li>Pages visited and time spent on the site</li>
                                </ul>
                                <p><strong>c. Cookies and Tracking Data</strong></p>
                                <p>
                                    We use cookies to improve your experience on our site. Please refer to our
                                    <a href="/cookie-policy" className="text-pink ms-1">Cookie Policy</a> for more information.
                                </p>

                                <h4>2. How We Use Your Information</h4>
                                <ul>
                                    <li>Respond to your inquiries or requests</li>
                                    <li>Provide services or information you request</li>
                                    <li>Improve the content and functionality of our website</li>
                                    <li>Analyze website traffic and usage patterns</li>
                                    <li>Ensure website security and prevent fraud</li>
                                </ul>

                                <h4>3. Legal Basis for Processing (if applicable)</h4>
                                <p>
                                    If you are located in the European Economic Area (EEA), our legal basis for processing your personal
                                    data may include:
                                </p>
                                <ul>
                                    <li>Your consent</li>
                                    <li>The performance of a contract</li>
                                    <li>Compliance with legal obligations</li>
                                    <li>Legitimate business interests</li>
                                </ul>

                                <h4>4. Sharing Your Information</h4>
                                <p>We do not sell or rent your personal data. We may share your information with:</p>
                                <ul>
                                    <li>Trusted third-party service providers (e.g., website hosting, analytics)</li>
                                    <li>Government or legal authorities if required by law</li>
                                    <li>Business partners only where necessary to deliver our services</li>
                                </ul>
                                <p>
                                    All third parties are required to respect the security of your personal data and treat it
                                    in accordance with applicable laws.
                                </p>

                                <h4>5. Data Security</h4>
                                <p>
                                    We implement appropriate technical and organizational measures to protect your personal data against
                                    unauthorized access, loss, or misuse. However, no system is completely secure, and we cannot guarantee
                                    absolute security.
                                </p>

                                <h4>6. Data Retention</h4>
                                <p>
                                    We retain personal data only for as long as necessary to:
                                </p>
                                <ul>
                                    <li>Fulfil the purposes we collected it for</li>
                                    <li>Comply with legal, regulatory, or contractual obligations</li>
                                    <li>Resolve disputes and enforce agreements</li>
                                </ul>

                                <h4>7. Your Rights</h4>
                                <p>Depending on your location, you may have the following rights:</p>
                                <ul>
                                    <li>Access to your personal data</li>
                                    <li>Correction of inaccurate data</li>
                                    <li>Deletion of your data</li>
                                    <li>Objection to or restriction of processing</li>
                                    <li>Data portability</li>
                                    <li>Withdrawal of consent</li>
                                </ul>
                                <p>
                                    To exercise any of these rights, please contact us using the details below.
                                </p>

                                <h4>8. Third-Party Links</h4>
                                <p>
                                    Our website may contain links to third-party websites. We are not responsible for their privacy practices,
                                    and we encourage you to read their privacy policies.
                                </p>

                                <h4>9. Changes to This Privacy Policy</h4>
                                <p>
                                    We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised
                                    "Effective Date." Please check back regularly to stay informed.
                                </p>

                               
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
}

export default PrivacyPolicy;
